// extracted by mini-css-extract-plugin
module.exports = {"vk":"styles_vk__0y_dg","telegram":"styles_telegram__R295F","twitter":"styles_twitter__GowGz","odnoklassniki":"styles_odnoklassniki__6LFdC","whatsapp":"styles_whatsapp__iIaRQ"};